/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */
import type { SVGProps } from 'react';

import type { DynamicIconProps } from '../../../icon/icon.types';
import { Icon } from '../../icon';

const CustomHybrid24 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="Custom Hybrid 24">
      <path
        fill="#0E0E0E"
        d="M11.036 1.53a2 2 0 0 1 1.928 0l8 4.4A2 2 0 0 1 22 7.683v8.634a2 2 0 0 1-1.036 1.753l-8 4.4a2 2 0 0 1-1.928 0l-8-4.4A2 2 0 0 1 2 16.317V7.683A2 2 0 0 1 3.036 5.93l8-4.4Z"
        className="Fill-Main"
      />
      <path
        fill="#fff"
        d="M8.114 17V7.77h1.885v3.679h4.004V7.77h1.885V17h-1.885v-3.757H9.999V17H8.114Z"
        className="Details"
      />
    </g>
  </svg>
);

const SIZE_MAP = {
  sm: CustomHybrid24,
  md: CustomHybrid24,
  lg: CustomHybrid24,
  xl: CustomHybrid24,
  xxl: CustomHybrid24,
  xxxl: CustomHybrid24,
};

export const CustomHybridIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: DynamicIconProps) => {
  return (
    <Icon
      data-testid={testId || 'custom-hybrid-icon'}
      icon={SIZE_MAP[size]}
      {...props}
      size={size}
    />
  );
};
